<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <!-- <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      /> -->
      
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex s12 md9">
      	 <va-card :title="$t('loan-GuarantorshipRequests')">
      	 	<template slot="actions">           
	            <va-button icon="fa fa-close" @click="$router.go(-1)">Cancel</va-button>	           
	        </template>
          <va-input
          class="ma-0"
          :value="term"
          :placeholder="$t('tables.searchByName')"
          @input="search"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
          <va-data-table
      :fields="mode ? detailedFields : fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >
      <template slot="icon">
        <va-icon name="fa fa-list" color="secondary" />
      </template>
      <template v-slot:name="props">
        {{ props.rowData.name }}
      </template>
      <template v-slot:phonenumber="props">
        {{ props.rowData.phonenumber  }}
      </template>
      <template v-slot:appliedamount="props">
        {{ props.rowData.appliedamount | Currency  }}
      </template>
    
      <template v-slot:AmountGuarantee="props">
        <div style="text-align: right;">{{ props.rowData.AmountGuarantee | Currency }}</div>
      </template>
      <template v-slot:details="props">
        <va-button  @click="ApproveLoanGuarantorship(props.rowData.LoanapplicationNo)">
                  {{ $t('Accept') }}
                 
                </va-button>  
      </template>
      <template v-slot:Reject="props">
        <va-button  @click="RejectGuarantorship(props.rowData.LoanapplicationNo,props.rowData.AmountGuarantee)">
                  {{ $t('Reject') }}
                 
                </va-button>  
      </template>
    </va-data-table>
      	 </va-card>
      </div>
    </div>
  
  </div>
</template>
<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'loan',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      term: null,
      loadSelect:false,
      processingError: false,
      payment_method : '',
      finalPost : '',
      details:{},
      Reject:{},
      formdata:{
        phone_no:'',
        loanType:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        grossSalary:'',
        user: '',
        phonenumber:'',
        
      },
      montlyrepayment:'',
      loanType:'',
        LoanapplicationNo:'',
        phonenumber:'',
        appliedamount:'',
        AmountGuarantee:'',
        repaymentperiod:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:name',
        title: this.$t('Applicant Name'),
        width: '30%',
        sortField: 'amount',
      }, 
      {
        name: '__slot:phonenumber',
        title: this.$t('Phone Number'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:appliedamount',
        title: this.$t('Applied Amount'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:AmountGuarantee',
        title: this.$t('Amount Guarantee'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:details',
        title: this.$t(''),
        width: '20%',
        sortField: 'details',
      },
      {
      name: '__slot:Reject',
        title: this.$t(''),
        width: '20%',
        sortField: 'Reject',
      }]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      console.log(this.term);
      return this.details.filter(item => {
        return item.description.toLowerCase().startsWith(this.term.toLowerCase()) || item.amount.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
    formReady () {

     },      
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.loanType.toLowerCase() === this.id.toLowerCase());      
    },
    
 
    onsubmit () {

    },


    ApproveLoanGuarantorship(LoanapplicationNo){

    const form = {
       user:this.userData.user_id,
       phonenumber: this.userData.mobile_number,
       LoanapplicationNo:LoanapplicationNo,
     };
     console.log(this.formdata.amount)

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

				axios.post(`${this.$apiUrl}ApproveGuarantorship`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == ''){              
			          self.showToast(`Guarantorship Approved succefully`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                setTimeout( () => window.location.reload(), 2500);
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
  
},
RejectGuarantorship(LoanapplicationNo){

const form = {
   user:this.userData.user_id,
   phonenumber: this.userData.mobile_number,
   LoanapplicationNo:LoanapplicationNo,
 };
 console.log(this.formdata.amount)

     this.loading = true
    var self = this

    let config = {
      headers: {
        Authorization: this.userData.user_id+' '+this.token
      }
      }

    axios.post(`${this.$apiUrl}RejectGuarantorship`, form, config) 
    .then(function (res) {
      self.loading = false					
      const resp = res.data;
      
      if(resp == ''){              
            self.showToast(`Guarantorship Request Rejected succefully`, {
              position: 'bottom-right',
              icon: "fa-check",
              duration: 2500,
            })
            setTimeout( () => window.location.reload(), 2500);
          } else {
            self.processingError = true
          }                 
    })
    .catch(function (error) {
      console.log(error)
    })

},
    GetGuarantorshipRequests () {
      this.loadSelect = true
      this.loading = true
      const self = this
      const form = {
  user:this.userData.user_id
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}LoadGuantorshipRequests`, form, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details = res.slice()

      })
      .catch(function (error) {
          console.log(error)
      })
    },
    moreDetails (LoanapplicationNo) {
      console.log(LoanapplicationNo);
      this.$router.push({name: 'loan-LoansMoreDetails', params: { loan_no:LoanapplicationNo}});
},
  },
  created () { 
    this.GetGuarantorshipRequests();
   
 
  }
}
</script>